/**
 * Protects admin routes: redirects to home if not authenticated.
 * Kirish: `hasValidAuth()` (access token) va `user.role` ikkalasi ham bo‘lishi kerak.
 * Eski localStorage’dagi rol yolg‘iz qoldirilganda token bo‘lmasa, API 401 beradi — shu holatni oldini oladi.
 * authLoading tugaguncha kutadi.
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './authContext';
import { hasValidAuth } from './authContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { authLoading, user } = useAuth();
  const location = useLocation();
  /**
   * Token bo'lmasa, localStorage'dagi eski `adminRole` / `adminUser` alone panelga kirishga yo'l qo'ymasligi kerak —
   * aks holda barcha API 401 (Unauthenticated) va bo'sh ma'lumotlar.
   */
  const authenticated = hasValidAuth() && !!user?.role;
  const hasAccess = !!user?.role;

  if (authLoading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{
          width: 40,
          height: 40,
          border: '3px solid rgba(31,50,126,0.2)',
          borderTopColor: '#1F327E',
          borderRadius: '50%',
          animation: 'adminSpin 0.8s linear infinite',
        }} />
      </div>
    );
  }

  if (!authenticated || !hasAccess) {
    const isDesktop = typeof navigator !== 'undefined' && /addedesktop/i.test(String(navigator.userAgent || ''));
    return <Navigate to={isDesktop ? '/desktop-login' : '/'} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
